import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import React from 'react'
import {Link, useLocation} from 'react-router-dom'
import {breadcrumbStyle} from './index.style'
import PropTypes from 'prop-types'

const Breadcrumbs = ({breadcrumbData}) => {
    const location = useLocation()
    const currentPath = location.pathname
    const {parentFolder, contentFolder} = breadcrumbData || {}

    const renderBreadcrumbItem = (folder) => {
        if (!folder) return null
        const folderUrlWithExt = folder.url + '.html'
        const isCurrent = currentPath === folderUrlWithExt
        return isCurrent ||
            contentFolder.url == '/sitemap' ||
            contentFolder.url == '/careers' ||
            contentFolder.url == '/team-cavenders-application.html' ||
            contentFolder.url == '/promotions/' ||
            contentFolder.url == '/storelocator/' ||
            contentFolder.url == '/help/' ||
            contentFolder.url == '/contactus/' ? (
            <Text as="span" className="text" key={folder.url}>
                {folder.folderName}
            </Text>
        ) : (
            <React.Fragment key={folder.url}>
                <Link to={folder.url} className="link">
                    {folder.folderName}
                </Link>
                <span className="breadcrumb-divider">{'//'}</span>
            </React.Fragment>
        )
    }

    return (
        <Box sx={breadcrumbStyle}>
            {Object.keys(breadcrumbData)?.length > 0 && (
                <nav className="navBar">
                    <Link to="/" className="link">
                        Home
                    </Link>{' '}
                    <span className="breadcrumb-divider">{'//'} </span>
                    {currentPath == '/career.html' ||
                    currentPath == '/team-cavenders-application.html' ||
                    currentPath == '/promotions/' ||
                    currentPath == '/storelocator' ||
                    currentPath == '/storelocator/state/' ||
                    currentPath == '/help/' ? null : (
                        <>
                            <Link to="/help/" className="link">
                                Customer Services
                            </Link>{' '}
                            {currentPath == '/help/' ? (
                                ''
                            ) : (
                                <span className="breadcrumb-divider">{'//'} </span>
                            )}
                        </>
                    )}
                    {parentFolder &&
                        contentFolder &&
                        parentFolder.url !== contentFolder.url &&
                        currentPath !== parentFolder.url &&
                        renderBreadcrumbItem(contentFolder)}
                </nav>
            )}
        </Box>
    )
}

Breadcrumbs.propTypes = {
    breadcrumbData: PropTypes.any
}

export default Breadcrumbs
